import React from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Featured1 from '../../assets/images/featured1.png'
import Featured2 from '../../assets/images/featured2.png'
import Featured3 from '../../assets/images/featured3.png'
import Featured4 from '../../assets/images/featured4.png'
import Featured5 from '../../assets/images/featured5.png'
import Featured6 from '../../assets/images/featured6.png'
import Featured7 from '../../assets/images/featured7.png'
import Featured8 from '../../assets/images/featured8.png'

function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >   
            <FontAwesomeIcon icon={faChevronRight} />
            {/* <img src={Arrow} className="icon next img-fluid" /> */}
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <FontAwesomeIcon icon={faChevronLeft} />
           {/* <img src={Arrow} className="icon prev img-fluid" /> */}
        </div>
    );
}
function Featured() {
    const explore = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 1,
        centerMode: true,
        arrows: true,
        nextArrow: <SampleNextArrow className="icon next"/>,
        prevArrow: <SamplePrevArrow className="icon prev"/>,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 3,
                    infinite: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    arrows: false
                }
            }

        ]
    };
    return (
        <section className="featured-work section-margin">
            <div className="container-fluid p-0">
                <div className="heading text-center main-padding">
                    <h2>Featured Work</h2>
                </div>
                <Slider className="featured" {...explore}>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Featured1} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">

                                <h3 className="name">Larry Hill</h3>

                                <h3>DarkLord#3995</h3>

                            </div>
                        </a>
                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Featured2} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">

                                <h3 className="name">Larry Hill</h3>

                                <h3>DarkLord#3995</h3>

                            </div>
                        </a>
                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Featured3} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">

                                <h3 className="name">Larry Hill</h3>

                                <h3>DarkLord#3995</h3>

                            </div>
                        </a>
                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Featured4} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">

                                <h3 className="name">Larry Hill</h3>

                                <h3>DarkLord#3995</h3>

                            </div>
                        </a>
                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Featured5} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">

                                <h3 className="name">Larry Hill</h3>

                                <h3>DarkLord#3995</h3>

                            </div>
                        </a>
                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Featured6} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">

                                <h3 className="name">Larry Hill</h3>

                                <h3>DarkLord#3995</h3>

                            </div>
                        </a>
                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Featured7} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">

                                <h3 className="name">Larry Hill</h3>

                                <h3>DarkLord#3995</h3>

                            </div>
                        </a>
                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Featured8} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">

                                <h3 className="name">Larry Hill</h3>

                                <h3>DarkLord#3995</h3>

                            </div>
                        </a>
                    </div>
                </Slider>

            </div>
        </section>
    )
}
export default Featured;